<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="订单序列号" prop="orderSeqNo">
                <Input type="text" v-model="searchForm.orderSeqNo" placeholder="请输入订单序列号" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="版权家用户id" prop="registerId">
                <Input type="text" v-model="searchForm.registerId" placeholder="请输入版权家用户id" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="子服务类型" prop="subBizType">
                <Input type="text" v-model="searchForm.subBizType" placeholder="请输入子服务类型编号" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="支付方式" prop="payWay">
                <!--<Input type="text" v-model="searchForm.payWay" placeholder="请输入支付方式" clearable style="width: 200px"/>-->
                <Select v-model="searchForm.payWay" clearable style="width: 200px">
                  <Option value="">全部</Option>
                  <Option value="AliPay">支付宝</Option>
                  <Option value="WechatPay">微信</Option>
                  <Option value="APPLEPAY">IOS内购</Option>
                  <Option value="Ewallet">钱包余额</Option>
                  <Option value="Free">免费</Option>
                  <Option value="Vip">VIP特权</Option>
                  <Option value="Give">赠送</Option>
                  <Option value="Commission">佣金</Option>
                  <Option value="RedEnvelope">红包</Option>
                </Select>
              </Form-item>
              <Form-item label="金额(非钱包 红包)" prop="payAmount">
                <Input v-model="searchForm.payAmount" placeholder="请输入金额" clearable style="width: 200px" type="number"/>
              </Form-item>
              <Form-item label="支付状态" prop="payStatus">
                <!--<Input type="text" v-model="searchForm.payWay" placeholder="请输入支付方式" clearable style="width: 200px"/>-->
                <Select v-model="searchForm.payStatus" clearable style="width: 200px">
                  <Option value="">全部</Option>
                  <Option value="unpay">未支付</Option>
                  <Option value="paid">支付</Option>
                  <Option value="cancel">已退款</Option>
                  <Option value="refund">退款</Option>
                  <Option value="regular-clearing">定期结算，通常第三方api接口</Option>
                </Select>
              </Form-item>
              <Form-item label="账号类型" prop="accType">
                <!--<Input type="text" v-model="searchForm.payWay" placeholder="请输入支付方式" clearable style="width: 200px"/>-->
                <Select v-model="searchForm.accType" clearable style="width: 200px">
                  <Option value="">全部</Option>
                  <Option value="person">个人</Option>
                  <Option value="enterprise">企业</Option>
                </Select>
              </Form-item>
              <span v-if="drop">
                <!--<Form-item label="子服务类型" prop="subBizType">
                  <Input type="text" v-model="searchForm.subBizType" placeholder="请输入子服务类型编号" clearable style="width: 200px"/>
                </Form-item>-->
              </span>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
              <!--<Button @click="add" type="primary" icon="md-add">添加(前端测试用)</Button>
              <Button @click="delAll" icon="md-trash">批量删除</Button>
              <Button @click="getDataList" icon="md-refresh">刷新</Button>-->
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >
        <FormItem label="id" prop="id" hidden>
          <Input v-model="form.id" style="width:100%"/>
        </FormItem>
        <!--<FormItem label="订单序列号" prop="orderSeqNo" >
          <Input v-model="form.orderSeqNo" style="width:100%"/>
        </FormItem>-->
        <!--<FormItem label="版权家用户id" prop="registerId" >-->
          <!--<Input v-model="form.registerId" style="width:100%"/>-->
        <!--</FormItem>-->
        <FormItem label="账户类型  person:个人  enterprise:企业，和业务主表中的个人企业含义相同" prop="accType" >
            <Select v-model="form.accType">
                <Option value="person">个人</Option>
                <Option value="enterprise">企业</Option>
            </Select>
          <!--<Input v-model="form.accType" style="width:100%"/>-->
        </FormItem>
        <FormItem label="支付金额" prop="payAmount" >
          <Input v-model="form.payAmount" style="width:100%"/>
        </FormItem>
        <FormItem label="支付方式  AliPay:支付宝,WechatPay:微信,APPLEPAY:IOS内购，RedEnvelope:红包,Ewallet:余额支付,Free:免费,Vip:VIP特权,Give:赠送" prop="payWay" >
          <Input v-model="form.payWay" style="width:100%"/>
        </FormItem>
        <FormItem label="是否使用红包  1使用  0 不使用" prop="useRedEnvelope" >
          <Input v-model="form.useRedEnvelope" style="width:100%"/>
        </FormItem>
        <FormItem label="红包金额" prop="redEnvelopAmount" >
          <Input v-model="form.redEnvelopAmount" style="width:100%"/>
        </FormItem>
        <FormItem label="是否使用余额  1使用  0 不使用" prop="useEwallet" >
          <Input v-model="form.useEwallet" style="width:100%"/>
        </FormItem>
        <FormItem label="电子钱包金额" prop="ewalletAmount" >
          <Input v-model="form.ewalletAmount" style="width:100%"/>
        </FormItem>
        <FormItem label="支付状态 unpay：“未支付” paid:支付 refund: 退款" prop="payStatus" >
          <Input v-model="form.payStatus" style="width:100%"/>
        </FormItem>
        <FormItem label="?支付时间" prop="payDate" >
            <DatePicker type="date" v-model="form.payDate" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="第三方支付结果序列号" prop="tranSerialsNo" >
          <Input v-model="form.tranSerialsNo" style="width:100%"/>
        </FormItem>
        <FormItem label="服务类型" prop="subBizType" >
          <Input v-model="form.subBizType" style="width:100%"/>
        </FormItem>
        <FormItem label="来源平台，这个是第三方appid" prop="source" >
          <Input v-model="form.source" style="width:100%"/>
        </FormItem>
        <FormItem label="备注" prop="remarks" >
          <Input v-model="form.remarks" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit" v-if="!form.id">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "RegisterVipMemberApplication",
  components: {
  },
  data() {
    return {
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        // sort: "create_date", // 默认排序字段
        // order: "desc", // 默认排序方式
        startDate: "", // 起始时间
        endDate: "" // 终止时间
      },
      selectDate: null,
      form: { // 添加或编辑表单对象初始化数据
        orderSeqNo: "",
        registerId: "",
        accType: "",
        payAmount: "",
        payWay: "",
        useRedEnvelope: "",
        redEnvelopAmount: "",
        useEwallet: "",
        ewalletAmount: "",
        payStatus: "",
        payDate: "",
        tranSerialsNo: "",
        subBizType: "",
        source: "",
        remarks: "",
      },
      // 表单验证规则
      formValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "订单序列号",
          key: "orderSeqNo",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "版权家用户id",
          key: "registerId",
          minWidth: 120,
          sortable: false,
        },
      {
          title: "版权家用户",
          key: "register.name",
          minWidth: 120,
          sortable: false,
          render: (h, params) => {
            return h("div", params.row.register.name)
          }
      },
        {
          title: "账户类型",
          key: "accType",
          minWidth: 120,
          sortable: false,
            render: (h, params) => {
                const accType = params.row.accType == 'person' ? '个人' : params.row.accType == 'enterprise' ? '企业' : '未知类型';
                return h("div", accType);
            }
        },
        {
          title: "支付金额",
          key: "payAmount",
          minWidth: 120,
          sortable: false,
        },
        {
          // title: "支付方式  AliPay:支付宝,WechatPay:微信,APPLEPAY:IOS内购，RedEnvelope:红包,Ewallet:余额支付,Free:免费,Vip:VIP特权,Give:赠送",
          title: "支付方式",
          key: "payWay",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "是否使用红包",
          key: "useRedEnvelope",
          minWidth: 120,
          sortable: false,
            render: (h, params) => {
                const useRedEnvelope = params.row.useRedEnvelope == '1' ? '使用' : params.row.useRedEnvelope == '0' ? '不使用' : '未知类型';
                return h("div", useRedEnvelope);
            }
        },
        {
          title: "红包金额",
          key: "redEnvelopAmount",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "是否使用余额",
          key: "useEwallet",
          minWidth: 120,
          sortable: false,
            render: (h, params) => {
                const useEwallet = params.row.useEwallet == '1' ? '使用' : params.row.useEwallet == '0' ? '不使用' : '未知类型';
                return h("div", useEwallet);
            }
        },
        {
          title: "电子钱包金额",
          key: "ewalletAmount",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "支付状态",
          key: "payStatus",
          minWidth: 120,
          sortable: false,
            render: (h, params) => {
                let payStatus = '';
                switch(params.row.payStatus){
                    case 'unpay': payStatus = '未支付'; break;
                    case 'paid': payStatus = '支付'; break;
                    case 'refund': payStatus = '退款'; break;
                    default: payStatus = '未知状态';
                }
                return h("div", payStatus);
            }
        },
        {
          title: "?支付时间",
          key: "payDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "第三方支付结果序列号",
          key: "tranSerialsNo",
          minWidth: 120,
          sortable: false,
        },
          {
              title: "类型",
              key: "bizType",
              minWidth: 120,
              sortable: false,
          },
        {
          title: "子类型",
          key: "subBizType",
          minWidth: 120,
          sortable: false,
        },
          {
              title: "子类型名称",
              key: "subBizTypeTitle",
              minWidth: 120,
              sortable: false,
              render(h, params){
                  return h("div", params.row.registerVipConfig.title);
              }
          },
        // {
        //   title: "来源平台，这个是第三方appid",
        //   key: "source",
        //   minWidth: 120,
        //   sortable: false,
        // },
        // {
        //   title: "备注",
        //   key: "remarks",
        //   minWidth: 120,
        //   sortable: false,
        // },
        // {
        //   title: "操作",
        //   key: "action",
        //   align: "center",
        //   width: 200,
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "primary",
        //             size: "small",
        //             icon: "ios-create-outline"
        //           },
        //           style: {
        //             marginRight: "5px"
        //           },
        //           on: {
        //             click: () => {
        //               this.edit(params.row);
        //             }
        //           }
        //         },
        //         "查看"
        //       )/*,
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "error",
        //             size: "small",
        //             icon: "md-trash"
        //           },
        //           on: {
        //             click: () => {
        //               this.remove(params.row);
        //             }
        //           }
        //         },
        //         "删除"
        //       )*/
        //     ]);
        //   }
        // }
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      this.getRequest("/registerVipMemberApplication/getByPage", this.searchForm).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.data = res.result.records;
          this.total = res.result.total;
        }
      });
      // this.data = [
      // ];
      // this.total = this.data.length;
      // this.loading = false;
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            this.postRequest("/registerVipMemberApplication/save", this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.getDataList();
                this.modalVisible = false;
              }
            });
            // 模拟请求成功
            // this.submitLoading = false;
            // this.$Message.success("操作成功");
            // this.getDataList();
            // this.modalVisible = false;
          } else {
            // 编辑
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          }
        }
      });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      this.modalVisible = true;
    },
    edit(v) {
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.modalVisible = true;
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.name + " ?",
        loading: true,
        onOk: () => {
          // 删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + v.id).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.getDataList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + ids).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.clearSelectAll();
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.clearSelectAll();
          this.getDataList();
        }
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>